const MALTA_TIME_ZONE = 'Europe/Malta';

/**
 * @param {string} validFor YYYY-MM-DD from deals API
 * @returns {Date}
 */
function dateFromValidFor(validFor) {
  if (typeof validFor === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(validFor)) {
    return new Date(`${validFor}T12:00:00`);
  }

  return new Date();
}

/**
 * @param {string} validFor
 * @returns {string}
 */
export function formatDealsEditionBadge(validFor) {
  const date = dateFromValidFor(validFor);
  const weekday = new Intl.DateTimeFormat('en-GB', {
    timeZone: MALTA_TIME_ZONE,
    weekday: 'long',
  }).format(date);

  return `${weekday}\u2019s edition`;
}

/**
 * @param {string} validFor
 * @returns {string}
 */
export function formatDealsEditionDate(validFor) {
  const date = dateFromValidFor(validFor);
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: MALTA_TIME_ZONE,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(date);
}

/**
 * Homepage section title date, e.g. "Saturday, 1 Aug".
 * @param {string} validFor
 * @returns {string}
 */
export function formatDealsEditionDateShort(validFor) {
  const date = dateFromValidFor(validFor);
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: MALTA_TIME_ZONE,
    weekday: 'long',
    day: 'numeric',
    month: 'short',
  }).format(date);
}
